import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { LocalDataSource } from 'ng2-smart-table';
import { tiens_phieuchi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-bamgkectu',
  templateUrl: './bamgkectu.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./bamgkectu.component.scss'],
    providers: [ListService, Repository]
})


export class bamgkectuComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';

  public tTuNgay: string;
  public tDenNgay: string;
  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();

  indLoading: boolean = false;
  
  source: LocalDataSource;
  inputthangs: any = [
    { text: "Tháng 1", value: 1 },
    { text: "Tháng 2", value: 2 },
    { text: "Tháng 3", value: 3 },
    { text: "Tháng 4", value: 4 },
    { text: "Tháng 5", value: 5 },
    { text: "Tháng 6", value: 6 },
    { text: "Tháng 7", value: 7 },
    { text: "Tháng 8", value: 8 },
    { text: "Tháng 9", value: 9 },
    { text: "Tháng 10", value: 10 },
    { text: "Tháng 11", value: 11 },
    { text: "Tháng 12", value: 12 },
    { text: "Quý I", value: 13 },
    { text: "Quý II", value: 14 },
    { text: "Quý III", value: 15 },
    { text: "Quý IV", value: 16 },
    { text: "Tuần này", value: 17 },
    { text: "Tháng này", value: 18 },
    { text: "Năm nay", value: 19 },
    { text: "Đầu năm đến nay", value: 20 },
  ];
  inputnguons: any = [{ text: 'Kinh phí tự chủ', value: 1 }, { text: 'Kinh phí không tự chủ', value: 0 }]
   
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor(  private repo: Repository) {
    }

  ngOnInit(): void {
    this.source = new LocalDataSource();
    }

  settings = {
    mode: 'external',
    selectMode: 'multi',
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    pager:{
      perPage: 1,
      display: false,
    },
    actions: {
    
      add: false,
      edit: false,
      delete: false,

      position: 'right',
    },
    columns: {

      Ma_Chung_Tu: {
        name: 'Ma_Chung_Tu',
        width: '100px',
        title: 'Mã CT ',

      },
      Ngay_Chung_Tu: {
        name: 'Ngay_Chung_Tu',
        width: '150px',
        title: 'Ngày',
        type: 'custom',
        renderComponent: DateViewComponent,
      },
      Tai_Khoan_No: {
        name: 'Tai_Khoan_No',
        width: '100px',
        title: 'TK Nợ',
      },
      Tai_Khoan_Co: {
        name: 'Tai_Khoan_Co',
        width: '100px',
        title: 'TK Có',
      },
      Dien_Giai_Chi_Tiet: {
        name: 'Dien_Giai_Chi_Tiet',
        width: '200px',
        title: 'Diễn giải',
      },
      So_Tien: {
        name: 'So_Tien',
        title: 'Số tiền',
        width: '100px',
        type: 'custom',
        renderComponent: NumberViewComponent,
      },
      Nguon: {
        name: 'Nguon',
        width: '250px',
        title: 'Nguồn',
      },
      Loai_Khoan: {
        name: 'Loai_Khoan',
        width: '100px',
        title: 'Loại khoản',
      },
      Tieu_Muc: {
        name: 'Tieu_Muc',
        width: '100px',
        title: 'Tiểu mục',
      },
      Khoan_Muc: {
        name: 'Khoan_Muc',
        width: '150px',
        title: 'Nhiệm vụ chi',
      },
      Nghiep_Vu: {
        name: 'Nghiep_Vu',
        width: '150px',
        title: 'Nghiệp vụ',
      },
      Cap_Phat: {
        name: 'Cap_Phat',
        width: '150px',
        title: 'Cấp phát',
      },
     
    },
  };
  khoangthoigian: number = 20;

  donviid: any;
  username: any;
  namketoan: any
  phanheid: any;
  nguonkinhphi: string;

  loadDataInit(tkhoangthoigian: number, tTuNgay: Date, tDenNgay: Date, tdonviid: any, tusername: any, tnamketoan: any, tphanheid: any)
  {
    this.donviid = tdonviid;
    this.username = tusername;
    this.namketoan = tnamketoan;
    this.phanheid = tphanheid;

    this.khoangthoigian = tkhoangthoigian;
    this.TuNgay = tTuNgay;
    this.DenNgay = tDenNgay;
  

    var tngay = (tTuNgay.getMonth() + 1) + '/' + tTuNgay.getDate() + '/' + tTuNgay.getFullYear();
    var dngay = (tDenNgay.getMonth() + 1) + '/' + tDenNgay.getDate() + '/' + tDenNgay.getFullYear();

    this.repo.postRequest("api/chungtu/get_laybangke/", { id: tdonviid, chuoi: this.nguonkinhphi, chuoi1: tusername, status: tnamketoan, chuoi2: tngay, chuoi3: dngay, chuoi4: this.phanheid })
      .subscribe(response => {
        console.log(response);
        
        this.source.load(response);
      });
  }
  public onChangeTuNgay(value: Date): void {
    console.log(this.TuNgay)
    
    if (value != null) {
      var tngay = (value.getMonth() + 1) + '/' + value.getDate() + '/' + value.getFullYear();
      var dngay = (this.DenNgay.getMonth() + 1) + '/' + this.DenNgay.getDate() + '/' + this.DenNgay.getFullYear();
      this.loadGrid(tngay, dngay);
    }
  
    
  }
  public onChangeDenNgay(value: Date): void {
   
    if (value != null) {
      var dngay = (value.getMonth() + 1) + '/' + value.getDate() + '/' + value.getFullYear();
      var tngay = (this.TuNgay.getMonth() + 1) + '/' + this.TuNgay.getDate() + '/' + this.TuNgay.getFullYear();
      this.loadGrid(tngay, dngay);
    }
  }
  onDoiTuongChange($event) {
    var getNow = new Date();
    var Nam = getNow.getFullYear();

    if (typeof $event !== "undefined") {
      if ($event.value > 0 && $event.value < 13) {
        this.TuNgay = new Date(Nam, $event.value - 1, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, $event.value, 0, 0, 0, 0);
      }
      if ($event.value === 13) {
        this.TuNgay = new Date(Nam, 0, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, 3, 0, 0, 0, 0);
      }
      if ($event.value === 14) {
        this.TuNgay = new Date(Nam, 3, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, 6, 0, 0, 0, 0);
      }
      if ($event.value === 15) {
        this.TuNgay = new Date(Nam, 6, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, 9, 0, 0, 0, 0);
      }
      if ($event.value === 16) {
        this.TuNgay = new Date(Nam, 9, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, 11, 31, 0, 0, 0);
      }
      if ($event.value === 17) {
        var current = new Date();     // get current date    
        var weekstart = current.getDate() - current.getDay() + 1;
        var weekend = weekstart + 6;       // end day is the first day + 6 
        this.TuNgay = new Date(current.setDate(weekstart));
        this.DenNgay = new Date(current.setDate(weekend));
      }
      if ($event.value === 18) {
        var thang = getNow.getMonth() + 1;
        this.TuNgay = new Date(Nam, thang - 1, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, thang, 0, 0, 0, 0);
      }
      if ($event.value === 19) {
        this.TuNgay = new Date(Nam, 0, 1, 0, 0, 0);
        this.DenNgay = new Date(Nam, 11, 31, 0, 0, 0);
      }
      if ($event.value === 20) {
        this.TuNgay = new Date(Nam, 0, 1, 0, 0, 0);
        this.DenNgay = getNow;
      }
    }
    var tngay = (this.TuNgay.getMonth() + 1) + '/' + this.TuNgay.getDate() + '/' + this.TuNgay.getFullYear();
    var dngay = (this.DenNgay.getMonth() + 1) + '/' + this.DenNgay.getDate() + '/' + this.DenNgay.getFullYear();
    this.loadGrid(tngay, dngay);
  }
  onNguonChange($event) {  
    var tngay = (this.TuNgay.getMonth() + 1) + '/' + this.TuNgay.getDate() + '/' + this.TuNgay.getFullYear();
    var dngay = (this.DenNgay.getMonth() + 1) + '/' + this.DenNgay.getDate() + '/' + this.DenNgay.getFullYear();
    this.loadGrid(tngay, dngay);
  }
  private loadGrid(tngay: string, dngay: string) {
   

    this.repo.postRequest("api/chungtu/get_laybangke/", { id: this.donviid, chuoi: this.nguonkinhphi, chuoi1: this.username, status: this.namketoan, chuoi2: tngay, chuoi3: dngay, chuoi4: this.phanheid })
      .subscribe(response => {
        console.log(response);
        this.source.load(response);
      });
  }

    keyTenPress(event: any) { 
      
  } 
  selectedRows: any;
  tong_tien_ct: number = 0;
  onRowSelect(event) {
    this.selectedRows = event.selected;
    this.tong_tien_ct = 0;
    if (this.selectedRows != null) {
      this.selectedRows.forEach(
        (div) => {
          this.tong_tien_ct = this.tong_tien_ct + (div.So_Tien != null ? div.So_Tien : 0);


        }
      );
    }
  }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    console.log(this.selectedRows);
    if (typeof this.selectedRows === "undefined" || this.selectedRows === null) {
      swal('Cảnh báo!', "Bạn chưa chọn phiếu chi", 'warning');
      return;
    }
    else
      this.save.emit(this.selectedRows);
    }
   
    
   

   


}
